<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Balance',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    watch: {},
    filters: {},
    computed: {},
    components: {}
}
</script>